export function getEnumStringValue(enumType: any, value: any): string {
  for (const key in enumType) {
    if (enumType[key] === value) {
      return key;
    }
  }
  return null;
}

export function extractEnumValues(enumType: any): string[] {
  return Object.keys(enumType).slice(Object.keys(enumType).length / 2);
}

export function getEnumByValue(enumType: any, value: any): any {
  for (const key in enumType) {
    if (enumType[key] === value) {
      return enumType[key];
    }
  }
  return null;
}
